import calls from '@/backend/api-calls'

const state = () => ({
  order: null,
  selected: [],
  allSelected: false,
  firstLoad: true,
  loading: false
})

// getters
const getters = {
  orderDetailIds: state => {
    return state.order.details.map(d => d.id);
  }
}

// actions
const actions = {
  getOrder: ({commit}, orderId) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.order.get(orderId)
        .then(resp => {
          commit("setOrder", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  getOrderDetail: ({commit, getters}, detailId) => {
    return new Promise((resolve, reject) => {
      calls.orderDetail.get(detailId).then(
        resp => {
          if (getters.orderDetailIds.includes(resp.data.id)) {
            commit("insertUpdatedDetail", resp.data);
          } else {
            commit("insertOrderDetail", resp.data);
          }
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateOrder: ({commit}, { orderId, data }) => {
    return new Promise((resolve, reject) => {
      calls.order.put(orderId, data)
        .then(resp => {
          commit("setOrder", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Order successfully updated'
          }, { root: true });
          
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addDetail: ({commit}, detail) => {
    return new Promise((resolve, reject) => {
      calls.orderDetails.post(detail).then(
        resp => {
          commit("insertOrderDetail", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Order detail successfully added'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateDetail: ({commit}, { detailId, data }) => {
    return new Promise((resolve, reject) => {
      calls.orderDetail.put(detailId, data).then(
        resp => {
          commit("insertUpdatedDetail", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Order successfully updated'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteDetail: ({commit}, detailId) => {
    return new Promise((resolve, reject) => {
      calls.orderDetail.delete(detailId).then(
        resp => {
          commit("removeDetail", detailId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Detail successfully deleted'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addBomDetail: ({dispatch}, detail) => {
    return new Promise((resolve, reject) => {
      calls.orderDetailsBoms.post(detail).then(
        resp => {
          dispatch("getOrderDetail", resp.data.order_details.id);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateBomDetail: ({dispatch}, { bomDetailId, data }) => {
    return new Promise((resolve, reject) => {
      calls.orderDetailsBom.put(bomDetailId, data).then(
        resp => {
          dispatch("getOrderDetail", resp.data.order_details.id);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteBomDetail: ({commit, dispatch}, { orderDetailId, bomDetailId }) => {
    return new Promise((resolve, reject) => {
      calls.orderDetailsBom.delete(bomDetailId).then(
        resp => {
          dispatch("getOrderDetail", orderDetailId);

          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Bom detail successfully deleted'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  assignStorage: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      calls.orderDetailsStorages.post(data).then(
        resp => {
          dispatch("getOrderDetail", data.order_detail_id);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Order item storage details successfully created'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.orderDetailIds);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setOrder(state, data) {
    state.order = data;
  },
  insertOrderDetail(state, orderDetail) {
    state.order.details.push(orderDetail)
  },
  insertUpdatedDetail(state, orderDetail) {
    state.order.details.forEach((detail, i) => {
      if (detail.id == orderDetail.id) {
        state.order.details.splice(i, 1, orderDetail);
      }
    })
  },
  removeDetail(state, orderDetailId) {
    state.order.details.forEach((detail, i) => {
      if (detail.id == orderDetailId) {
        state.order.details.splice(i, 1);
      }
    })

    let index = state.selected.indexOf(orderDetailId);
    if (index != -1) {
      state.selected.splice(index, 1);
    }
  },
  removeBomDetail(state, {orderDetailId, bomDetailId}) {
    state.order.details.forEach(detail => {
      if (detail.id == orderDetailId) {
        detail.order_boms.forEach((bom, i) => {
          if (bom.id == bomDetailId) {
            detail.order_boms.splice(i, 1);
          }
        })
      }
    })
  },
  selectAll(state, orderDetailIds) {
    state.allSelected = true;
    orderDetailIds.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}